import React, { useState, useEffect } from 'react';
import axios from '../Axiosinstance';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';  // Import Toastify CSS
import { buttonBackgroundColor, Password, Username } from '../common';

const MeetingParticipants = ({ meetingIds, onlineclasslink, clicked }) => {

  console.log("meetingIds", meetingIds);
  console.log("onlineclasslink", onlineclasslink);
  console.log("clicked", clicked);
  const [sessionId, setSessionId] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(''); // Error state for general error messages
  const [openDialog, setOpenDialog] = useState(false);  // State to control the dialog visibility
  const [meetingId, setMeetingId] = useState(null);  // Add state to store meetingId
  const [meetingLink, setMeetingLink] = useState(null);

  const basicAuth = btoa(`${Username}:${Password}`);

  useEffect(() => {
    // Retrieve meetingId, meetingLink, and sessionId from localStorage
    const storedMeetingId = localStorage.getItem('meetingId');
    const storedMeetingLink = localStorage.getItem('onlineMeetingLink');
    const storedSessionId = localStorage.getItem('sessionId');

    // Check if meetingId exists in localStorage
    if (storedMeetingId) {
      setMeetingId(storedMeetingId);  // Set meetingId from localStorage
      console.log('Meeting ID from LocalStorage:', storedMeetingId);
    } else {
      console.error('No meeting ID found in localStorage');
    }

    // Check if meetingLink exists in localStorage
    if (storedMeetingLink) {
      setMeetingLink(storedMeetingLink);  // Set meetingLink from localStorage
      console.log('Meeting Link from LocalStorage:', storedMeetingLink);
    } else {
      console.error('No meeting Link found in localStorage');
    }

    // Check if sessionId exists in localStorage
    if (storedSessionId) {
      setSessionId(storedSessionId);  // Set sessionId from localStorage
      console.log('Session ID from LocalStorage:', storedSessionId);
    }

    // If meetingId exists, fetch the session data
    if (storedMeetingId) {
      const fetchSessionData = async () => {
        const options = {
          method: 'GET',
          url: `https://api.dyte.io/v2/meetings/${storedMeetingId}/active-session`,
          headers: {
            Accept: 'application/json',
            Authorization: `Basic ${basicAuth}`,
          },
        };

        try {
          const { data } = await axios.request(options);
          if (data.success) {
            const sessionData = data.data;
            setSessionId(sessionData.id);  // Set the session ID if active
            localStorage.setItem('sessionId', sessionData.id);  // Store in localStorage
            setLoading(false);
            console.log('Session ID fetched successfully');
          } else {
            setSessionId(null);  // Session is not active
            setLoading(false);
            setError('Session not active or has ended');
          }
        } catch (error) {
          console.error('Error fetching session data:', error);
          setLoading(false);
          setError('No active session found');
        }
      };

      fetchSessionData();
    }

    // Fetch participants if sessionId exists
    if (storedSessionId) {
      const fetchParticipants = async () => {
        const options = {
          method: 'GET',
          url: `https://api.dyte.io/v2/sessions/${storedSessionId}/participants`,
          headers: {
            Accept: 'application/json',
            Authorization: `Basic ${basicAuth}`,
          },
        };

        try {
          const { data } = await axios.request(options);
          if (data.success) {
            const updatedParticipants = data.data.participants.map(participant => ({
              ...participant,
              meetingEndTime: new Date().toISOString(),
              id: parseInt(participant.id, 10),
            }));
            setParticipants(updatedParticipants);
            console.log('Participants fetched successfully', updatedParticipants);
          } else {
            setError('Failed to fetch participants');
          }
        } catch (error) {
          console.error('Error fetching participants:', error);
          setError('Error fetching participants');
        }
      };

      fetchParticipants();
    }
  }, []); // This useEffect will run only once on component mount





  const saveAttendanceToDB = async () => {

    const token = localStorage.getItem('jwtToken');
    if (!token) {
      console.log('JWT Token is missing');
      return;
    }



    try {


      const checkResponse = await axios.get(`/api/attendance-details/session/${sessionId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (checkResponse.data.success && checkResponse.data.exists) {
        toast.error('Attendance has already been taken for this session');
        console.log('Attendance has already been taken for this session');
        return;
      }

      // Fetch the latest participants data before saving it
      const options = {
        method: 'GET',
        url: `https://api.dyte.io/v2/sessions/${sessionId}/participants`, // Use sessionId from state
        headers: {
          Accept: 'application/json',
          Authorization: `Basic ${basicAuth}`,
        }
      };

      const { data } = await axios.request(options);
      if (!data.success) {
        toast.error('Failed to fetch participants');
        return;
      }

      const updatedParticipants = data.data.participants.map(participant => ({
        ...participant,
        meetingEndTime: new Date().toISOString(),
        id: parseInt(participant.id, 10),
      }));

      // Attendance data mapping
      const attendanceData = updatedParticipants.map(participant => {
        const createdAt = new Date(participant.created_at);

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        };

        const meetingEndTime = formatDate(new Date());
        const localCreatedAt = createdAt.toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        });

        const [date, time] = localCreatedAt.split(', '); // Split by comma and space
        const [month, dayName, year] = date.split('/'); // Further split date
        const dateObj = new Date(`${year}-${month}-${dayName}`); // YYYY-MM-DD format
        const day = dateObj.toLocaleString('en-US', { weekday: 'long' });
        const formattedDate = `${year}-${month.padStart(2, '0')}-${dayName.padStart(2, '0')}`; // Reformat as yyyy-MM-dd

        return {
          created_at: localCreatedAt,
          custom_participant_id: participant.custom_participant_id,
          display_name: participant.display_name,
          preset_name: participant.preset_name,
          joined_at: participant.joined_at,
          left_at: participant.left_at,
          duration: participant.duration,
          meetingEndTime: participant.meetingEndTime, // Convert to LocalDateTime
          session_id: participant.session_id,
          date: formattedDate,
          time,
          day,
          online_class_link: meetingLink,
          meeting_start_time: participant.joined_at,
          meetingId: participant.meetingId,
        };
      });

      console.log('Attendance Data to be sent:', attendanceData);

      // Save attendance to the backend
      const response = await axios.post('/api/attendance-details', attendanceData, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        toast.success('Attendance details saved successfully to the database');
        console.log('Sending meetingId:', meetingId);

        // Now call the /mark-attendance endpoint
        const markAttendanceResponse = await axios.post('/mark-attendance', null, {
          params: { online_class_link: meetingLink },  // Pass meetingId as a query parameter
        });

        if (markAttendanceResponse.status === 200) {
          toast.success('Attendance marked successfully!');

          setParticipants([]); // Reset participants after successful save
          localStorage.removeItem('meetingId');
          localStorage.removeItem('onlineMeetingLink');
          localStorage.removeItem('sessionId');
        } else {
          toast.error('Failed to mark attendance');
        }
      } else {
        toast.error('Failed to save attendance details');
      }
    } catch (error) {
      console.error('Error saving attendance to backend:', error);
      toast.error('Error saving attendance to backend');
    }
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmSave = () => {
    saveAttendanceToDB();
    handleCloseDialog();
  };

  if (loading) return <div>Loading...</div>;
  // Only show the error if something actually went wrong
  if (error) return <div>{error}</div>;

  return (
    <div>
      <h3>Last Session</h3>
      <p>Session ID: {sessionId || 'No active session'}</p>
      <p>{ }</p>
      {/* Only show the participants list if the session is active */}
      {sessionId ? (
        <>


          {/* Save attendance button */}
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenDialog}
            style={{ marginTop: '20px', backgroundColor: buttonBackgroundColor, color: 'white' }}
          >
            Mark Attendance
          </Button>

          {/* Confirmation Dialog */}
          <Dialog open={openDialog} onClose={handleCloseDialog}>
            <DialogTitle>Confirm Save</DialogTitle>
            <DialogContent>
              Are you sure you want to save the attendance now? Once saved, attendance cannot be undone.
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog} color="secondary" style={{ backgroundColor: buttonBackgroundColor, color: 'white' }}>
                No
              </Button>
              <Button onClick={handleConfirmSave} color="primary" style={{ backgroundColor: buttonBackgroundColor, color: 'white' }}>
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <div>
          <Button
            variant="outlined"
            color="secondary"
            disabled
            style={{ marginTop: '20px' }}
          >
            No Active Session
          </Button>
        </div>
      )}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeButton={true}
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />

      <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} />
    </div>
  );
};

export default MeetingParticipants;
